export const useLocalStorage = () => {
  const setItem = (p: { key: string; value: string }) => {
    try {
      localStorage.setItem(p.key, p.value);
    } catch (error) {
      console.error('ローカルストレージへの保存に失敗しました。', error);
    }
  };

  const getItem = (p: { key: string }): string | null => {
    try {
      return localStorage.getItem(p.key);
    } catch (error) {
      console.error('ローカルストレージからの読み取りに失敗しました。', error);
      return null;
    }
  };

  return { setItem, getItem };
};
